export const SOFTLINE_API_ESL_FLASH_EXISTS = '/v1/esl/exists/{{idartstamm}}';
export const SOFTLINE_API_ESL_FLASH = '/v1/esl/flash';
